export default {
    listagem: {
        titulo_pagina: 'Registros de Auditoría'
    },
    filtro: {
        evento: 'Evento',
        modelo: 'Modelo',
        chave_modelo: 'Clave del Modelo',
        veus_id: 'ID de Veus',
        usuario: 'Usuario',
        periodo_padrao: 'Período Padrão',
        periodo_personalizado: 'Periodo Personalizado',
        mais_filtros: 'Más Filtros',
        filtrar_button: 'Filtrar',
        limpar_button: 'Limpiar Filtros'
    },
    periodos: {
        trinta_minutos: 'Hace 30 minutos',
        uma_hora: 'Hace 1 hora',
        hoje: 'Hoy',
        sete_dias: 'Últimos 7 días',
        mes_atual: 'Mes actual',
        mes_anterior: 'Mes anterior',
        ano_atual: 'Año actual',
        ano_anterior: 'Año anterior'
    },
    tabela: {
        campos: {
            evento: 'Evento',
            modelo: 'Modelo',
            chave_modelo: 'Clave del Modelo',
            veus_id: 'ID de Veus',
            usuario: 'Usuario',
            criado_em: 'Creado en',
            atualizado_em: 'Actualizado en',
            valores_antigos: 'Valores Anteriores',
            novos_valores: 'Nuevos Valores',
            ip: 'IP',
            user_agent: 'User Agent',
            url: 'URL',
            tags: 'Tags'
        }
    },
    detail: {
        titulo_pagina: "Registros de Auditoría"
    }
}
